import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Copy, Check } from 'lucide-react';
import toast from 'react-hot-toast';
import ShareKitQuickBar from './ShareKitQuickBar';
import InviteContactsButton from './InviteContactsButton';
import { useLanguage } from '../../contexts/LanguageContext';
import { copyTextToClipboard } from '../../utils/clipboard';

function ShareReferralPanel({ url, message, className = '', showCopyAll = true }) {
  const { t, formatMessage } = useLanguage();
  const text = message || formatMessage(t.enrola.defaultShareFallback, { url });
  const [copied, setCopied] = useState(false);

  const copyAll = async () => {
    try {
      await copyTextToClipboard(text);
      setCopied(true);
      toast.success(t.enrola.messageCopied);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error(t.enrola.copyFailed);
    }
  };

  return (
    <div className={`surface-elevated p-4 sm:p-5 ${className}`}>
      <InviteContactsButton message={text} className="mb-4" />
      <p className="stat-label mb-3">{t.enrola.shareQuick}</p>
      <ShareKitQuickBar url={url} message={message} className="mb-5" />

      <p className="stat-label mb-2">{t.enrola.suggestedMessage}</p>
      <div className="flex gap-2 rounded-2xl border border-secondary-200/50 bg-secondary-50/60 p-3  ">
        <p className="min-w-0 flex-1 text-sm leading-relaxed text-secondary-800 ">{text}</p>
        {showCopyAll && (
          <motion.button
            type="button"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={copyAll}
            className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border transition-[border-color,background-color] duration-200 ${
              copied
                ? 'border-success-300 bg-success-50 text-success-600  '
                : 'border-secondary-200 bg-white text-secondary-600 hover:border-orange-200 hover:bg-orange-50/50   '
            }`}
            title={t.enrola.copyMessageTitle}
          >
            {copied ? <Check className="h-5 w-5" strokeWidth={2.5} /> : <Copy className="h-5 w-5" />}
          </motion.button>
        )}
      </div>
    </div>
  );
}

export default ShareReferralPanel;
